import axios, { type Method } from "axios";

import { handleBeforeRequest } from "@tally/utils/handleBeforeRequest";
import { handleErrorLog } from "@tally/utils/handleErrorLogs";
import { handleSignOut } from "@tally/utils/handleToken";

const baseURL =
	import.meta.env.VITE_SCORE_API_AC ?? import.meta.env.VITE_SCORE_API;

const request = async <T>(
	method: Method,
	path: string,
	body?: unknown,
): Promise<T> => {
	const headers: Record<string, string> = {};

	await handleBeforeRequest({ url: path, headers });

	try {
		const response = await axios.request<T>({
			method,
			url: `${baseURL}${path}`,
			data: body,
			headers,
		});

		return response.data;
	} catch (error) {
		handleErrorLog(error);

		if (axios.isAxiosError(error) && error.response?.status === 401) {
			await handleSignOut();
		}

		throw error;
	}
};

export const alovaScoreInstance = {
	Get: <T = unknown>(path: string) => request<T>("GET", path),
	Post: <T = unknown>(path: string, body?: unknown) =>
		request<T>("POST", path, body),
	Put: <T = unknown>(path: string, body?: unknown) =>
		request<T>("PUT", path, body),
	Patch: <T = unknown>(path: string, body?: unknown) =>
		request<T>("PATCH", path, body),
	Delete: <T = unknown>(path: string, body?: unknown) =>
		request<T>("DELETE", path, body),
};
